export { GenerarContrarecibosPPModalEdit, Props } from "./modal";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/contrarecibos/modales/generarcontrarecibospp/index.tsx